import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/simulators/$id/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/simulators/$id/simulate',
      params: { id: params.id },
    })
  },
})
